import initialState from './initialState';
import {
  RECEIVE_FILE_TRANSFER_DETAILS,
  REQUEST_FILE_TRANSFER_DETAILS
} from '../actions/fileTransferDetailsActions';
import {
  CLEAR_CURRENT_VENDOR_FILES_LIST,
  RECEIVE_832_FILES, RECEIVE_MASS_AGREEMENT_FILE_IMPORT,
  RECEIVE_VENDOR_ASSOCIATION_FILE_IMPORT,
  RECEIVE_VENDOR_FILE_REIMPORT_USING_VARIATION_REPORT,
  REQUEST_832_FILES, REQUEST_MASS_AGREEMENT_FILE_IMPORT,
  REQUEST_VENDOR_ASSOCIATION_FILE_IMPORT,
  REQUEST_VENDOR_FILE_REIMPORT_USING_VARIATION_REPORT,
} from '../actions/filesActions';
import {
  REQUEST_COST_DATA,
  RECEIVE_COST_DATA,
  REQUEST_BUSINESS_CENTER_DETAILS,
  RECEIVE_BUSINESS_CENTER_DETAILS,
  REQUEST_PRICE_RECORD_TYPES,
  RECEIVE_PRICE_RECORD_TYPES,
  REQUEST_ADHOC_COST_FILE_IMPORT,
  SUBMIT_GENERATE_COST_REPORTS,
  RECEIVE_ADHOC_COST_FILE_IMPORT_RESPONSE,
  REQUEST_MULTIPLE_ADHOC_COST_FILE_IMPORT,
  RECEIVE_MULTIPLE_ADHOC_COST_FILE_IMPORT_RESPONSE,
  REQUEST_ALL_MODULES,
  RECEIVE_ALL_MODULES,
  REQUEST_MODULE_PRICE_EXPORT,
  RECEIVE_MODULE_PRICE_EXPORT,
  RECEIVE_MODULE_PRICE_IMPORT,
  REQUEST_MODULE_PRICE_IMPORT,
  RECEIVE_ITEM_PRICE,
  REQUEST_ITEM_PRICE,
  CREATE_MODULE_GROUP,
  CREATE_COMMODITY_GROUP,
  REQUEST_ALL_COMMODITIES,
  RECEIVE_ALL_COMMODITIES,
  REQUEST_COMMODITY_DETAILS,
  RECEIVE_COMMODITY_DETAILS,
  RECEIVE_MODULE_GROUPS_ASSOCIATIONS,
  REQUEST_MODULE_GROUPS_ASSOCIATIONS,
  REQUEST_MODULE_GROUP_UPDATE,
  RECEIVE_MODULE_GROUP_UPDATE,
  RECEIVE_MODULE_GROUP_DELETE,
  REQUEST_MODULE_GROUP_LOADING_AREA_ASSIGNMENT,
  REQUEST_MODULE_GROUP_COMMODITY_ASSIGNMENT,
  REQUEST_ALL_LOADING_AREAS,
  RECEIVE_MODULE_GROUP_LOADING_AREA_ASSIGNMENT,
  RECEIVE_MODULE_GROUP_COMMODITY_ASSIGNMENT,
  RECEIVE_ALL_LOADING_AREAS,
  REQUEST_MODULE_GROUP_DELETE,
  REQUEST_COMMODITY_GROUP_UPDATE,
  RECEIVE_COMMODITY_GROUP_UPDATE,
  RECEIVE_COMMODITY_GROUP_DELETE,
  REQUEST_COMMODITY_GROUP_ITEM_ASSIGNMENT,
  RECEIVE_COMMODITY_GROUP_ITEM_ASSIGNMENT,
  REQUEST_COMMODITY_GROUP_DELETE,
  RECEIVE_ALL_PRICE_MODULE_ITEMS,
  REQUEST_ALL_PRICE_MODULE_ITEMS,
  RECEIVE_LOADING_AREA_DETAILS,
  RECEIVE_LOADING_AREA_CREATE,
  RECEIVE_LOADING_AREA_DELETE,
  RECEIVE_LOADING_AREA_UPDATE,
  REQUEST_LOADING_AREA_UPDATE,
  REQUEST_LOADING_AREA_CREATE,
  REQUEST_LOADING_AREA_DELETE,
  REQUEST_LOADING_AREA_DETAILS,
  RECEIVE_CREATE_MODULE_GROUP,
  RECEIVE_CREATE_COMMODITY_GROUP,
  REQUEST_MODULE_GROUP_REACTIVATE,
  RECEIVE_MODULE_GROUP_REACTIVATE,
  REQUEST_COMMODITY_GROUP_REACTIVATE,
  RECEIVE_COMMODITY_GROUP_REACTIVATE,
  REQUEST_LOADING_AREA_REACTIVATE,
  RECEIVE_LOADING_AREA_REACTIVATE,
  REQUEST_UPDATE_MODULE_PRICES,
  RECEIVE_UPDATE_MODULE_PRICES,
} from '../actions/costMaintenanceActions';

import {
  REQUEST_COST_VIEW_DATA,
  RECEIVE_COST_VIEW_DATA,
  REQUEST_COST_VIEW_DETAILED_DATA,
  RECEIVE_COST_VIEW_DETAILED_DATA,
  REQUEST_WAREHOUSES_AND_OPCOS,
} from '../actions/costViewActions';

import {
  RECEIVE_ERROR_IN_832_FILES_FETCH,
  RECEIVE_ERROR_IN_FILE_TRANSFER_DETAILS_FETCH,
  RECEIVE_ERROR_IN_REPORT_DETAILS_FETCH,
  RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH,
  RECEIVE_ERROR_IN_USER_GROUP_DETAILS_FETCH,
  RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH_OF_SELECTED_USER,
  RECEIVE_ERROR_IN_USERS_FETCH,
  RECEIVE_ERROR_IN_ALL_USER_GROUPS_FETCH,
  RECEIVE_ERROR_IN_VENDOR_FILE_IMPORT,
  RECEIVE_ERROR_IN_VENDOR_FILE_LOG_FETCH,
  RECEIVE_ERROR_IN_BUSINESS_CENTERS_FETCH,
  RECEIVE_ERROR_IN_PRICE_RECORD_TYPES_FETCH,
  RECEIVE_ERROR_IN_VENDORS_FETCH,
  RECEIVE_ERROR_IN_SUPPLIER_SUPPORT_REQUEST_SUBMISSION,
  RECEIVE_ERROR_IN_HELP_TOPIC_CONTENT_FETCH,
  RECEIVE_ERROR_IN_REQUEST_DETAILS_FETCH,
  RECEIVE_ERROR_IN_WORKSPACE_REQUEST_SUBMISSION,
  RECEIVE_ERROR_IN_COST_DATA_FETCH,
  RECEIVE_ERROR_IN_ADHOC_COST_FILE_IMPORT,
  RECEIVE_ERROR_IN_REQUEST_STATUS_UPDATE,
  RECEIVE_ERROR_IN_WORKSPACE_REQUEST_ACTION_CHANGE,
  RECEIVE_ERROR_IN_WORKSPACE_REQUEST_COMMENT_SUBMISSION,
  RECEIVE_ERROR_WHEN_SAVING_USER_MANAGEMENT_DETAILS,
  RECEIVE_ERROR_IN_ENTERPRISE_COST_MASTER_DATA_FETCH,
  RECEIVE_ERROR_IN_ENTERPRISE_COST_DATA_FETCH,
  RECEIVE_ERROR_IN_EARNED_INCOME_MAPPINGS_FETCH,
  RECEIVE_ERROR_IN_SAS_FD_DETAILS_FETCH,
  RECEIVE_ERROR_WHEN_SAVING_VENDOR_SAS_DETAILS,
  RECEIVE_ERROR_WHEN_ADDING_VENDOR_SAS_DETAILS,
  RECEIVE_ERROR_WHEN_SAVING_ITEM_SAS_FD_DETAILS,
  RECEIVE_ERROR_IN_SAS_FD_FILE_IMPORT,
  RECEIVE_ERROR_IN_SUPPLIER_ONBOARD_DETAILS_FETCH,
  RECEIVE_ERROR_IN_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS_FETCH,
  RECEIVE_ERROR_UPDATE_SUPPLIER_CONTACT,
  RECEIVE_ERROR_IN_AGREEMENT_NUMBERS,
  RECEIVE_ERROR_IN_AGREEMENT_UPDATE,
  RECEIVE_ERROR_IN_AGREEMENT_CREATE,
  RECEIVE_ERROR_IN_AGREEMENT_RECALCULATE,
  RECEIVE_ERROR_IN_AGREEMENT_RECALCULATION_DECLINE,
  RECEIVE_ERROR_IN_AGREEMENT_DELETE,
  RECEIVE_ERROR_IN_POST_COMMENT,
  RECEIVE_ERROR_IN_AGREEMENT_DETAILS,
  RECEIVE_ERROR_IN_AGREEMENTS_SEARCH_DATA_FETCH,
  RECEIVE_ERROR_IN_AGREEMENT_REPORT_CREATION,
  RECEIVE_ERROR_IN_MASS_ITEM_UPLOAD_REQUEST,
  RECEIVE_ERROR_IN_AGREEMENT_CLONE,
  RECEIVE_ERROR_IN_EXCEPTIONS,
  RECEIVE_EXCEPTIONS_SAVE_ERROR,
  RECEIVE_EXCEPTIONS_DELETE_ERROR,
  RECEIVE_ERROR_IN_EXCEPTION_CODES,
  RECEIVE_ERROR_IN_COST_IMPACT_TERM_FILE_IMPORT,
  RECEIVE_ERROR_IN_EI_TERM_DETAILS_FETCH,
  RECEIVE_ERROR_IN_FORMULA_GROUP_REQUEST,
  RECEIVE_ERROR_IN_MODULES_FETCH,
  RECEIVE_ERROR_IN_MODULE_PRICE_EXPORT,
  RECEIVE_ERROR_IN_ITEM_PRICE,
  RECEIVE_ERROR_IN_MODULE_PRICE_IMPORT,
  RECEIVE_ERROR_IN_MODULE_GROUP_CREATE,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_CREATE,
  RECEIVE_ERROR_IN_COMMODITIES_FETCH,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_FETCH,
  RECEIVE_ERROR_IN_MODULE_GROUPS_ASSOCIATION_FETCH,
  RECEIVE_ERROR_IN_MODULE_GROUP_UPDATE,
  RECEIVE_ERROR_IN_MODULE_GROUP_DELETE,
  RECEIVE_ERROR_IN_MODULE_GROUP_COMMODITY_ASSIGNMENT,
  RECEIVE_ERROR_IN_MODULE_GROUP_LOADING_AREA_ASSIGNMENT,
  RECEIVE_ERROR_IN_LOADING_AREAS_FETCH,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_UPDATE,
  RECEIVE_ERROR_IN_PRICE_MODULE_ITEMS_FETCH,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_ITEM_ASSIGNMENT,
  RECEIVE_ERROR_IN_MODULE_GROUP_REACTIVATE,
  RECEIVE_ERROR_IN_COMMODITY_GROUP_REACTIVATE,
  RECEIVE_ERROR_IN_LOADING_AREA_DETAILS_FETCH,
  RECEIVE_ERROR_IN_LOADING_AREA_CREATE,
  RECEIVE_ERROR_IN_LOADING_AREA_DELETE,
  RECEIVE_ERROR_IN_LOADING_AREA_UPDATE,
  RECEIVE_ERROR_IN_LOADING_AREA_REACTIVATE,
  RECEIVE_ERROR_IN_COST_VIEW_DATA_FETCH,
  RECEIVE_ERROR_IN_COST_VIEW_DETAILED_DATA_FETCH,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_CODES_FETCH,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_CREATION,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_UPDATE,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_DELETION,
  RECEIVE_ERROR_IN_COST_FILE_TEMPLATE,
  RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH_DELETED,
  RECEIVE_ERROR_IN_MODULE_PRICES_UPDATE,
  RECEIVE_ERROR_IN_WAREHOUSE_AND_OPCO_FETCH
} from '../actions/errorDialogActions';
import {
  RECEIVE_VENDOR_PRICE_FILES_IMPORT_LOG,
  REQUEST_VENDOR_PRICE_FILES_IMPORT_LOG
} from '../actions/filesLogActions';
import {
  DELETE_REPORT_TEMPLATE, CREATE_AGREEMENT_REPORT, RECEIVE_AGREEMENT_REPORT_CREATION_STATUS,
  RECEIVE_AGREEMENT_SUMMARY_REPORT_CREATION_STATUS, RECEIVE_COST_AUDIT_REPORT_DATA,
  RECEIVE_REPORT_TEMPLATE_DELETE_STATUS, RECEIVE_REPORT_TEMPLATE_DETAILS, RECEIVE_REPORTS_LOG,
  REQUEST_COST_AUDIT_REPORT_DATA, REQUEST_REPORT_TEMPLATE_DETAILS, REQUEST_REPORTS_LOG,
} from '../actions/reportsActions';
import {
  FETCH_USERS,
  RECEIVE_USERS,
  FETCH_ALL_USER_GROUPS,
  RECEIVE_ALL_USER_GROUPS,
  RECEIVE_USER_PROFILE_DETAILS,
  REQUEST_USER_PROFILE_DETAILS,
  REQUEST_USER_PROFILE_MANAGEMENT_DETAILS,
  REQUEST_USER_GROUP_DETAILS,
  RECEIVE_USER_GROUP_DETAILS,
  RECEIVE_USER_PROFILE_MANAGEMENT_DETAILS,
  SAVE_SUPERVISOR_FOR_USER,
  RECEIVE_SUPERVISOR_PERSIST_STATUS_FOR_USER,
  SAVE_VENDORS_ASSOCIATION_FOR_USER,
  SAVE_GROUP,
  SAVE_DIRECT_USER_GROUP_ASSOCIATION,
  RECEIVE_VENDOR_ASSOCIATION_PERSIST_STATUS_FOR_USER,
  RECEIVE_GROUP_PERSIST_STATUS,
  RECEIVE_DIRECT_USER_GROUP_ASSOCIATION_PERSIST_STATUS,
  REMOVE_SUPERVISOR_OF_USER,
  RECEIVE_SUPERVISOR_REMOVE_STATUS_FOR_USER,
  REQUEST_USER_PROFILE_DETAILS_OF_SELECTED_USER,
  RECEIVE_USER_PROFILE_DETAILS_OF_SELECTED_USER,
  REQUEST_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS,
  RECEIVE_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS,
  REQUEST_SUPPLIER_ONBOARD_DETAILS,
  RECEIVE_SUPPLIER_ONBOARD_DETAILS,
  RECEIVE_SUPPLIER_PERSIST_STATUS,
  RECEIVE_SUPPLIER_UPDATE_STATUS,
  SAVE_SUPPLIER,
  UPDATE_SUPPLIER,
  TRIGGER_UPDATE_SUPPLIER_CONTACT,
  SUCCESS_UPDATE_SUPPLIER_CONTACT
} from '../actions/userManagementActions';
import {
  RECEIVE_ALL_VENDORS,
  REQUEST_ALL_VENDORS,
  REQUEST_VENDORS_BY_ITEM,
  RECEIVE_VENDORS_BY_ITEM,
  REQUEST_ALL_OPCOS,
  RECEIVE_ALL_OPCOS,
  RECEIVE_OPCO_FETCH_ERROR,
  REQUEST_VENDOR_BASES,
  REQUEST_WAREHOUSES,
  RECEIVE_WAREHOUSES,
  RECEIVE_WAREHOUSES_FETCH_ERROR
} from '../actions/vendorActions';

import {
  REQUEST_AGREEMENT_NUMBERS,
  RECEIVE_AGREEMENT_NUMBERS,
  RECEIVE_AGREEMENT_DATA,
  REQUEST_AGREEMENT_DETAILS,
  RECEIVE_AGREEMENT_DETAILS,
  FETCH_EXCEPTIONS,
  RECEIVE_WHSE_EXCEPTIONS,
  RECEIVE_OPCO_EXCEPTIONS,
  RECEIVE_VENDOR_BASES,
  FETCH_BUSINESS_CENTERS,
  RECEIVE_BUSINESS_CENTERS,
  FETCH_SAS_FD_DETAILS,
  RECEIVE_SAS_FD_DETAILS,
  RECEIVE_SAS_VALUE_UPDATE_STATUS_FOR_VENDOR,
  RECEIVE_SAS_FD_FILE_IMPORT,
  SAVE_SAS_FD_DETAILS_FOR_ITEM,
  CREATE_AGREEMENT,
  UPDATE_AGREEMENT,
  RECEIVE_CREATE_AGREEMENT_RESPONSE,
  RECEIVE_UPDATE_AGREEMENT_RESPONSE,
  RECALCULATE_AGREEMENT,
  RECEIVE_RECALCULATE_AGREEMENT_RESPONSE,
  DECLINE_RECALCULATION,
  RECEIVE_RECALC_DECLINE_RESPONSE,
  DELETE_AGREEMENT,
  RECEIVE_DELETE_AGREEMENT_RESPONSE,
  RECEIVE_ITEM_GROUP_DELETE_RESPONSE,
  POST_AGREEMENT_COMMENT,
  RECEIVE_COMMENT_WITH_ATTACHMENT,
  FETCH_VENDOR_BASES,
  FETCH_AGREEMENT_ASSOCIATED_VENDORS,
  SAVE_SAS_VALUE_FOR_VENDOR,
  ADD_SAS_VALUE_FOR_VENDOR,
  RECEIVE_SAS_VALUE_ADD_STATUS_FOR_VENDOR,
  REQUEST_SAS_FD_FILE_IMPORT,
  RECEIVE_SAS_FD_DETAILS_UPDATE_STATUS_FOR_ITEM,
  FETCH_AGREEMENTS_SEARCH_DATA,
  RECEIVE_AGREEMENTS_SEARCH_DATA,
  FETCH_ITEM_GROUPS,
  FETCH_VENDOR_ITEMS,
  RECEIVE_ITEM_GROUPS,
  RECEIVE_ERROR_IN_ITEM_GROUPS,
  REQUEST_ITEM_GROUP,
  RECEIVE_ITEM_GROUP,
  RECEIVE_VENDOR_ITEMS_FETCH_ERROR,
  RECEIVE_VENDOR_ITEMS,
  UPDATE_ITEM_GROUP,
  RECEIVE_ITEM_GROUP_UPDATE_RESPONSE,
  RECEIVE_ITEM_GROUP_UPDATE_ERROR,
  CREATE_ITEM_GROUPS,
  RECEIVE_ITEM_GROUP_CREATE_RESPONSE,
  RECEIVE_ITEM_GROUP_CREATE_ERROR,
  DELETE_ITEM_GROUP,
  RECEIVE_ITEM_GROUP_DELETE_ERROR,
  RECEIVE_CLONE_AGREEMENT_RESPONSE,
  CLONE_AGREEMENT,
  SAVE_EXCEPTIONS,
  RECEIVE_EXCEPTIONS_SAVE_RESPONSE,
  DELETE_EXCEPTIONS,
  RECEIVE_EXCEPTIONS_DELETE_RESPONSE,
  FETCH_EXCEPTION_CODES,
  RECEIVE_EXCEPTION_CODES,
  RECEIVE_ERROR_IN_ITEM_GROUP_FETCH,
} from '../actions/agreementActions';
import {
  REQUEST_OVERAGE_FILE_IMPORT,
  RECEIVE_OVERAGE_FILE_IMPORT,
  FETCH_EI_TERM_DETAILS,
  RECEIVE_EI_TERM_DETAILS,
} from '../actions/costImpactTermActions';
import {
  REQUEST_ENTERPRISE_COST_MASTER_DATA,
  REQUEST_ENTERPRISE_COST_DATA,
  RECEIVE_ENTERPRISE_COST_MASTER_DATA,
  RECEIVE_ENTERPRISE_COST_DATA
} from '../actions/enterpriseCostActions';
import {
  SUBMIT_SUPPLIER_SUPPORT_REQUEST,
  RECEIVE_SUPPLIER_SUPPORT_REQUEST_SUBMISSION_RESPONSE,
  REQUEST_HELP_TOPIC_CONTENT,
  RECEIVE_HELP_TOPIC_CONTENT,
  FETCH_REQUEST_DETAILS,
  RECEIVE_REQUEST_DETAILS,
  SUBMIT_WORKSPACE_REQUEST,
  RECEIVE_WORKSPACE_REQUEST_SUBMISSION_RESPONSE,
  UPDATE_SELECTED_REQUEST_STATUS,
  SUBMIT_WORKSPACE_REQUEST_ACTION_CHANGE,
  RECEIVE_WORKSPACE_REQUEST_ACTION_RESPONSE,
  ADD_WORKSPACE_REQUEST_COMMENT
} from '../actions/workspaceActions';
import {
  FETCH_EARNED_INCOME_MAPPINGS,
  RECEIVE_EARNED_INCOME_MAPPINGS
} from '../actions/utilitiesActions';
import {
  REQUEST_MARKET_GROUPS,
  UPDATE_MARKET_GROUPS,
  REQUEST_SELECTED_MARKET_GROUP,
  UPDATE_SELECTED_MARKET_GROUP_DATA,
  REQUEST_MARKET_GROUP_ITEMS,
  OPEN_LOADER_FOR_MARKET_GROUP_OPERATION,
  UPDATE_MARKET_GROUP_ITEMS,
  RECEIVE_SUCCESS_IN_MARKET_GROUP_OPERATION,
  UPDATE_MASS_ITEM_ASSOCIATION_DATA,
  SUBMIT_NEW_MARKET_RATE,
} from '../actions/formulaGroupActions';
import {
  FETCH_SEGMENT_CODES,
  FETCH_SEGMENT_DETAILS,
  SAVE_SEGMENT_DETAILS,
  UPDATE_SEGMENT_DETAILS,
  DELETE_SEGMENT_DETAILS,
  RECIEVE_SEGMENT_CODES,
  RECIEVE_SEGMENT_DETAILS,
  RECIEVE_SEGMENT_DETAILS_PERSIST_STATUS,
  RECIEVE_SEGMENT_DETAILS_UPDATE_STATUS,
  RECIEVE_SEGMENT_DETAILS_DELETE_STATUS,
  RECIEVE_SEGMENT_DETAILS_INACTIVATE_STATUS,
  FETCH_SEGMENT_VERSIONS,
  RECEIVE_SEGMENT_VERSIONS,
  SEGMENT_VERSIONS_ERROR,
  FETCH_SEGMENT_VENDOR_MAPPING,
  RECIEVE_SEGMENT_VENDOR_MAPPING,
  REQUEST_SEGMENT_DETAILS_BY_SEGMENT_VERSION,
  RECEIVE_SEGMENT_DETAILS_BY_SEGMENT_VERSION
} from '../actions/segmentDataActions';
import {
  FETCH_COST_FILE_TEMPLATE,
  RECEIVE_COST_FILE_TEMPLATE,
  SAVE_COST_FILE_TEMPLATE,
  RECEIVE_COST_FILE_TEMPLATE_SAVE_STATUS,
  DELETE_COST_FILE_TEMPLATE,
  RECEIVE_COST_FILE_TEMPLATE_DELETE_STATUS,
} from '../actions/costFileTemplateActions';
import { SEGMENT_DETAIL_ACTION_TYPES } from '../../helpers/constants';
import { OPEN_LOADER_FOR_MASS_ITEM_UPLOAD_OPERATION, RECEIVE_SUCCESS_IN_MASS_ITEM_UPLOAD_OPERATION, UPDATE_ITEM_GROUP_MASS_ITEM_ASSOCIATION_DATA } from '../actions/massItemUploadActions';

export default function loaderReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return initialState.loader;
  }
  switch (type) {
    case RECEIVE_FILE_TRANSFER_DETAILS:
    case RECEIVE_832_FILES:
    case RECEIVE_VENDOR_ASSOCIATION_FILE_IMPORT:
    case RECEIVE_MASS_AGREEMENT_FILE_IMPORT:
    case CLEAR_CURRENT_VENDOR_FILES_LIST:
    case RECEIVE_ERROR_IN_VENDOR_FILE_IMPORT:
    case RECEIVE_VENDOR_PRICE_FILES_IMPORT_LOG:
    case RECEIVE_ERROR_IN_FILE_TRANSFER_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_VENDOR_FILE_LOG_FETCH:
    case RECEIVE_ERROR_IN_REPORT_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_832_FILES_FETCH:
    case RECEIVE_VENDOR_FILE_REIMPORT_USING_VARIATION_REPORT:
    case RECEIVE_REPORTS_LOG:
    case RECEIVE_USER_PROFILE_DETAILS:
    case RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_USER_GROUP_DETAILS_FETCH:
    case RECEIVE_USER_PROFILE_MANAGEMENT_DETAILS:
    case RECEIVE_USERS:
    case RECEIVE_ALL_USER_GROUPS:
    case RECEIVE_SUPERVISOR_PERSIST_STATUS_FOR_USER:
    case RECEIVE_SUPERVISOR_REMOVE_STATUS_FOR_USER:
    case RECEIVE_VENDOR_ASSOCIATION_PERSIST_STATUS_FOR_USER:
    case RECEIVE_GROUP_PERSIST_STATUS:
    case RECEIVE_DIRECT_USER_GROUP_ASSOCIATION_PERSIST_STATUS:
    case RECEIVE_USER_GROUP_DETAILS:
    case RECEIVE_USER_PROFILE_DETAILS_OF_SELECTED_USER:
    case RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH_OF_SELECTED_USER:
    case RECEIVE_ERROR_IN_USERS_FETCH:
    case RECEIVE_ERROR_IN_ALL_USER_GROUPS_FETCH:
    case RECEIVE_ALL_VENDORS:
    case RECEIVE_VENDORS_BY_ITEM:
    case RECEIVE_ALL_OPCOS:
    case RECEIVE_ERROR_IN_VENDORS_FETCH:
    case RECEIVE_OPCO_FETCH_ERROR:
    case RECEIVE_ERROR_IN_BUSINESS_CENTERS_FETCH:
    case RECEIVE_PRICE_RECORD_TYPES:
    case RECEIVE_ERROR_IN_PRICE_RECORD_TYPES_FETCH:
    case RECEIVE_COST_AUDIT_REPORT_DATA:
    case RECEIVE_REPORT_TEMPLATE_DETAILS:
    case RECEIVE_REPORT_TEMPLATE_DELETE_STATUS:
    case RECEIVE_AGREEMENT_REPORT_CREATION_STATUS:
    case RECEIVE_AGREEMENT_SUMMARY_REPORT_CREATION_STATUS:
    case RECEIVE_ERROR_IN_SUPPLIER_SUPPORT_REQUEST_SUBMISSION:
    case RECEIVE_SUPPLIER_SUPPORT_REQUEST_SUBMISSION_RESPONSE:
    case RECEIVE_HELP_TOPIC_CONTENT:
    case RECEIVE_ERROR_IN_HELP_TOPIC_CONTENT_FETCH:
    case RECEIVE_REQUEST_DETAILS:
    case RECEIVE_ERROR_IN_REQUEST_DETAILS_FETCH:
    case RECEIVE_WORKSPACE_REQUEST_SUBMISSION_RESPONSE:
    case RECEIVE_ERROR_IN_WORKSPACE_REQUEST_SUBMISSION:
    case RECEIVE_ERROR_IN_REQUEST_STATUS_UPDATE:
    case RECEIVE_WORKSPACE_REQUEST_ACTION_RESPONSE:
    case RECEIVE_ERROR_IN_WORKSPACE_REQUEST_ACTION_CHANGE:
    case RECEIVE_COST_DATA:
    case RECEIVE_ERROR_IN_COST_DATA_FETCH:
    case RECEIVE_ADHOC_COST_FILE_IMPORT_RESPONSE:
    case RECEIVE_MULTIPLE_ADHOC_COST_FILE_IMPORT_RESPONSE:
    case RECEIVE_ERROR_IN_ADHOC_COST_FILE_IMPORT:
    case RECEIVE_ERROR_IN_WORKSPACE_REQUEST_COMMENT_SUBMISSION:
    case RECEIVE_ENTERPRISE_COST_MASTER_DATA:
    case RECEIVE_ENTERPRISE_COST_DATA:
    case RECEIVE_ERROR_IN_ENTERPRISE_COST_MASTER_DATA_FETCH:
    case RECEIVE_ERROR_IN_ENTERPRISE_COST_DATA_FETCH:
    case RECEIVE_EARNED_INCOME_MAPPINGS:
    case RECEIVE_ERROR_IN_EARNED_INCOME_MAPPINGS_FETCH:
    case RECEIVE_ERROR_IN_AGREEMENT_REPORT_CREATION:
    case RECEIVE_SUCCESS_IN_MASS_ITEM_UPLOAD_OPERATION:
    case RECEIVE_ERROR_IN_MASS_ITEM_UPLOAD_REQUEST:
    case UPDATE_ITEM_GROUP_MASS_ITEM_ASSOCIATION_DATA:
    case UPDATE_MARKET_GROUPS:
    case UPDATE_SELECTED_MARKET_GROUP_DATA:
    case UPDATE_MARKET_GROUP_ITEMS:
    case RECEIVE_SUCCESS_IN_MARKET_GROUP_OPERATION:
    case RECEIVE_ERROR_IN_FORMULA_GROUP_REQUEST:
    case UPDATE_MASS_ITEM_ASSOCIATION_DATA:
    case RECEIVE_ERROR_IN_SAS_FD_DETAILS_FETCH:
    case RECEIVE_BUSINESS_CENTERS:
    case RECEIVE_SAS_FD_DETAILS:
    case RECEIVE_SAS_VALUE_UPDATE_STATUS_FOR_VENDOR:
    case RECEIVE_ERROR_WHEN_SAVING_VENDOR_SAS_DETAILS:
    case RECEIVE_SAS_VALUE_ADD_STATUS_FOR_VENDOR:
    case RECEIVE_ERROR_WHEN_ADDING_VENDOR_SAS_DETAILS:
    case RECEIVE_ERROR_WHEN_SAVING_ITEM_SAS_FD_DETAILS:
    case RECEIVE_SAS_FD_FILE_IMPORT:
    case RECEIVE_SAS_FD_DETAILS_UPDATE_STATUS_FOR_ITEM:
    case RECEIVE_ERROR_IN_SAS_FD_FILE_IMPORT:
    case RECEIVE_AGREEMENT_NUMBERS:
    case RECEIVE_AGREEMENT_DATA:
    case RECEIVE_AGREEMENT_DETAILS:
    case RECEIVE_VENDOR_BASES:
    case RECEIVE_ITEM_GROUPS:
    case RECEIVE_WHSE_EXCEPTIONS:
    case RECEIVE_OPCO_EXCEPTIONS:
    case RECEIVE_ERROR_IN_EXCEPTIONS:
    case RECEIVE_ERROR_IN_AGREEMENT_NUMBERS:
    case RECEIVE_ERROR_IN_AGREEMENT_UPDATE:
    case RECEIVE_ERROR_IN_AGREEMENT_CREATE:
    case RECEIVE_ERROR_IN_AGREEMENT_RECALCULATE:
    case RECEIVE_ERROR_IN_AGREEMENT_RECALCULATION_DECLINE:
    case RECEIVE_ERROR_IN_AGREEMENT_DELETE:
    case RECEIVE_ERROR_IN_AGREEMENT_DETAILS:
    case RECEIVE_AGREEMENTS_SEARCH_DATA:
    case RECEIVE_ERROR_IN_AGREEMENTS_SEARCH_DATA_FETCH:
    case RECEIVE_ERROR_IN_ITEM_GROUPS:
    case RECEIVE_WAREHOUSES:
    case RECEIVE_WAREHOUSES_FETCH_ERROR:
    case RECEIVE_EXCEPTIONS_SAVE_ERROR:
    case RECEIVE_EXCEPTIONS_DELETE_ERROR:
    case RECEIVE_EXCEPTION_CODES:
    case RECEIVE_ERROR_IN_EXCEPTION_CODES:
    case RECEIVE_OVERAGE_FILE_IMPORT:
    case RECEIVE_EI_TERM_DETAILS:
    case RECEIVE_ERROR_IN_COST_IMPACT_TERM_FILE_IMPORT:
    case RECEIVE_ERROR_IN_EI_TERM_DETAILS_FETCH:
    case RECEIVE_ALL_MODULES:
    case RECEIVE_ERROR_IN_MODULES_FETCH:
    case RECEIVE_ALL_COMMODITIES:
    case RECEIVE_ERROR_IN_COMMODITIES_FETCH:
    case RECEIVE_MODULE_PRICE_EXPORT:
    case RECEIVE_ERROR_IN_MODULE_PRICE_EXPORT:
    case RECEIVE_MODULE_PRICE_IMPORT:
    case RECEIVE_ERROR_IN_MODULE_PRICE_IMPORT:
    case RECEIVE_ITEM_PRICE:
    case RECEIVE_ERROR_IN_ITEM_PRICE:
    case RECEIVE_ERROR_IN_MODULE_GROUP_CREATE:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_CREATE:
    case RECEIVE_COMMODITY_DETAILS:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_FETCH:
    case RECEIVE_MODULE_GROUPS_ASSOCIATIONS:
    case RECEIVE_ERROR_IN_MODULE_GROUPS_ASSOCIATION_FETCH:
    case RECEIVE_ERROR_IN_MODULE_GROUP_COMMODITY_ASSIGNMENT:
    case RECEIVE_ERROR_IN_MODULE_GROUP_LOADING_AREA_ASSIGNMENT:
    case RECEIVE_ERROR_IN_LOADING_AREAS_FETCH:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_UPDATE:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_ITEM_ASSIGNMENT:
    case RECEIVE_ERROR_IN_PRICE_MODULE_ITEMS_FETCH:
    case RECEIVE_ERROR_IN_LOADING_AREA_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_LOADING_AREA_CREATE:
    case RECEIVE_ERROR_IN_LOADING_AREA_DELETE:
    case RECEIVE_ERROR_IN_LOADING_AREA_UPDATE:
    case RECEIVE_COST_VIEW_DATA:
    case RECEIVE_COST_VIEW_DETAILED_DATA:
    case RECIEVE_SEGMENT_CODES:
    case RECIEVE_SEGMENT_DETAILS:
    case RECIEVE_SEGMENT_DETAILS_PERSIST_STATUS:
    case RECIEVE_SEGMENT_DETAILS_UPDATE_STATUS:
    case RECIEVE_SEGMENT_DETAILS_DELETE_STATUS:
    case RECIEVE_SEGMENT_DETAILS_INACTIVATE_STATUS:
    case RECIEVE_SEGMENT_VENDOR_MAPPING:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_CODES_FETCH:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_CREATION:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_UPDATE:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_DELETION:
    case RECEIVE_ERROR_IN_COST_FILE_TEMPLATE:
    case RECEIVE_COST_FILE_TEMPLATE:
    case RECEIVE_COST_FILE_TEMPLATE_SAVE_STATUS:
    case RECEIVE_COST_FILE_TEMPLATE_DELETE_STATUS:
    case RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH_DELETED:
    case RECEIVE_SEGMENT_DETAILS_BY_SEGMENT_VERSION:
    case RECEIVE_ERROR_IN_WAREHOUSE_AND_OPCO_FETCH:
      return { ...state, show: false };

    case RECEIVE_SUPPLIER_ONBOARD_DETAILS:
    case RECEIVE_SUPPLIER_UPDATE_STATUS:
    case RECEIVE_SUPPLIER_PERSIST_STATUS:
    case RECEIVE_ERROR_WHEN_SAVING_USER_MANAGEMENT_DETAILS:
    case RECEIVE_ERROR_IN_SUPPLIER_ONBOARD_DETAILS_FETCH:
    case RECEIVE_ERROR_IN_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS_FETCH:
    case SUCCESS_UPDATE_SUPPLIER_CONTACT:
    case RECEIVE_ERROR_UPDATE_SUPPLIER_CONTACT:
    case RECEIVE_CREATE_AGREEMENT_RESPONSE:
    case RECEIVE_CLONE_AGREEMENT_RESPONSE:
    case RECEIVE_UPDATE_AGREEMENT_RESPONSE:
    case RECEIVE_RECALCULATE_AGREEMENT_RESPONSE:
    case RECEIVE_RECALC_DECLINE_RESPONSE:
    case RECEIVE_DELETE_AGREEMENT_RESPONSE:
    case RECEIVE_ITEM_GROUP:
    case RECEIVE_VENDOR_ITEMS:
    case RECEIVE_VENDOR_ITEMS_FETCH_ERROR:
    case RECEIVE_ITEM_GROUP_UPDATE_RESPONSE:
    case RECEIVE_ITEM_GROUP_CREATE_RESPONSE:
    case RECEIVE_ITEM_GROUP_UPDATE_ERROR:
    case RECEIVE_ITEM_GROUP_CREATE_ERROR:
    case RECEIVE_ITEM_GROUP_DELETE_RESPONSE:
    case RECEIVE_ITEM_GROUP_DELETE_ERROR:
    case RECEIVE_EXCEPTIONS_SAVE_RESPONSE:
    case RECEIVE_EXCEPTIONS_DELETE_RESPONSE:
    case RECEIVE_SEGMENT_VERSIONS:
    case SEGMENT_VERSIONS_ERROR:
    case RECEIVE_ERROR_IN_ITEM_GROUP_FETCH:
    case RECEIVE_ERROR_IN_MODULE_GROUP_UPDATE:
    case RECEIVE_ERROR_IN_MODULE_GROUP_DELETE:
    case RECEIVE_MODULE_GROUP_UPDATE:
    case RECEIVE_MODULE_GROUP_DELETE:
    case RECEIVE_MODULE_GROUP_LOADING_AREA_ASSIGNMENT:
    case RECEIVE_MODULE_GROUP_COMMODITY_ASSIGNMENT:
    case RECEIVE_ALL_LOADING_AREAS:
    case RECEIVE_COMMODITY_GROUP_UPDATE:
    case RECEIVE_COMMODITY_GROUP_DELETE:
    case RECEIVE_COMMODITY_GROUP_ITEM_ASSIGNMENT:
    case RECEIVE_ALL_PRICE_MODULE_ITEMS:
    case RECEIVE_LOADING_AREA_DETAILS:
    case RECEIVE_LOADING_AREA_CREATE:
    case RECEIVE_LOADING_AREA_DELETE:
    case RECEIVE_LOADING_AREA_UPDATE:
    case RECEIVE_CREATE_MODULE_GROUP:
    case RECEIVE_CREATE_COMMODITY_GROUP:
    case RECEIVE_MODULE_GROUP_REACTIVATE:
    case RECEIVE_ERROR_IN_MODULE_GROUP_REACTIVATE:
    case RECEIVE_COMMODITY_GROUP_REACTIVATE:
    case RECEIVE_ERROR_IN_COMMODITY_GROUP_REACTIVATE:
    case RECEIVE_LOADING_AREA_REACTIVATE:
    case RECEIVE_ERROR_IN_LOADING_AREA_REACTIVATE:
    case RECEIVE_ERROR_IN_COST_VIEW_DATA_FETCH:
    case RECEIVE_ERROR_IN_COST_VIEW_DETAILED_DATA_FETCH:
    case RECEIVE_UPDATE_MODULE_PRICES:
    case RECEIVE_ERROR_IN_MODULE_PRICES_UPDATE:
      return {
        ...state,
        show: false,
      };
    case RECEIVE_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS:
      return { ...state, show: false };
    case RECEIVE_BUSINESS_CENTER_DETAILS:
      return { ...state, show: false, isBusinessCenterLoading: false };
    case REQUEST_VENDOR_ASSOCIATION_FILE_IMPORT:
    case REQUEST_MASS_AGREEMENT_FILE_IMPORT:
    case REQUEST_VENDOR_FILE_REIMPORT_USING_VARIATION_REPORT:
      return {
        ...state, type: 'modal', show: true
      };

    case REQUEST_COST_AUDIT_REPORT_DATA:
    case CREATE_AGREEMENT_REPORT:
      return {
        ...state, type: 'modal', show: true, message: 'Creating report... this might take a while'
      };

    case REQUEST_MULTIPLE_ADHOC_COST_FILE_IMPORT:
    case REQUEST_ADHOC_COST_FILE_IMPORT:
      return {
        ...state, type: 'modal', show: true, message: 'Importing cost data from file... this might take a while'
      };

    case CREATE_AGREEMENT:
      return {
        ...state, type: 'modal', show: true, message: 'Creating agreement...'
      };

    case CLONE_AGREEMENT:
      return {
        ...state, type: 'modal', show: true, message: 'Clonning agreement...'
      };

    case UPDATE_AGREEMENT:
      return {
        ...state, type: 'modal', show: true, message: 'Updating agreement...'
      };

    case RECALCULATE_AGREEMENT:
      return {
        ...state, type: 'modal', show: true, message: 'Creating Recalculate Request...'
      };

    case DECLINE_RECALCULATION:
      return {
        ...state, type: 'modal', show: true, message: 'Declining recalculation for agreement...'
      };

    case DELETE_AGREEMENT:
      return {
        ...state, type: 'modal', show: true, message: 'Deleting agreement...'
      };

    case DELETE_ITEM_GROUP:
      return {
        ...state, type: 'modal', show: true, message: 'Deleting item group...'
      };

    case SAVE_EXCEPTIONS:
      return {
        ...state, type: 'modal', show: true, message: 'Saving exceptions...'
      };

    case DELETE_EXCEPTIONS:
      return {
        ...state, type: 'modal', show: true, message: 'Deleting exceptions...'
      };

    case POST_AGREEMENT_COMMENT:
      return {
        ...state, type: undefined, show: false, showLoaderIcon: true
      };

    case RECEIVE_COMMENT_WITH_ATTACHMENT:
    case RECEIVE_ERROR_IN_AGREEMENT_CLONE:
    case RECEIVE_ERROR_IN_POST_COMMENT:
      return {
        ...state, type: undefined, show: false, showLoaderIcon: false
      };

    case REQUEST_COST_DATA:
    case REQUEST_COST_VIEW_DATA:
    case REQUEST_COST_VIEW_DETAILED_DATA:
      return {
        ...state, type: 'modal', show: true, message: 'Loading cost data...'
      };
    case REQUEST_MODULE_GROUP_UPDATE:
    case REQUEST_MODULE_GROUP_LOADING_AREA_ASSIGNMENT:
    case REQUEST_MODULE_GROUP_COMMODITY_ASSIGNMENT:
      return {
        ...state, type: 'modal', show: true, message: 'Updating module data...'
      };
    case REQUEST_UPDATE_MODULE_PRICES:
      return {
        ...state, type: 'modal', show: true, message: 'Updating module prices...'
      };
    case REQUEST_COMMODITY_GROUP_UPDATE:
    case REQUEST_COMMODITY_GROUP_ITEM_ASSIGNMENT:
      return {
        ...state, type: 'modal', show: true, message: 'Updating commodity data...'
      };
    case REQUEST_LOADING_AREA_UPDATE:
      return {
        ...state, type: 'modal', show: true, message: 'Updating loading area data...'
      };

    case FETCH_USERS:
    case FETCH_ALL_USER_GROUPS:
    case REQUEST_USER_PROFILE_MANAGEMENT_DETAILS:
    case REQUEST_ALL_VENDORS:
    case REQUEST_ALL_OPCOS:
    case REQUEST_VENDOR_BASES:
    case REQUEST_ALL_MODULES:
    case REQUEST_REPORT_TEMPLATE_DETAILS:
    case REQUEST_USER_GROUP_DETAILS:
    case FETCH_REQUEST_DETAILS:
    case REQUEST_ENTERPRISE_COST_MASTER_DATA:
    case REQUEST_ENTERPRISE_COST_DATA:
    case FETCH_EARNED_INCOME_MAPPINGS:
    case REQUEST_MARKET_GROUPS:
    case REQUEST_SELECTED_MARKET_GROUP:
    case REQUEST_MARKET_GROUP_ITEMS:
    case SUBMIT_NEW_MARKET_RATE:
    case FETCH_VENDOR_BASES:
    case FETCH_AGREEMENT_ASSOCIATED_VENDORS:
    case FETCH_SAS_FD_DETAILS:
    case FETCH_BUSINESS_CENTERS:
    case FETCH_EXCEPTIONS:
    case REQUEST_AGREEMENT_DETAILS:
    case REQUEST_ITEM_GROUP:
    case UPDATE_ITEM_GROUP:
    case CREATE_ITEM_GROUPS:
    case REQUEST_ALL_COMMODITIES:
    case FETCH_VENDOR_ITEMS:
    case REQUEST_WAREHOUSES:
    case FETCH_EI_TERM_DETAILS:
    case FETCH_EXCEPTION_CODES:
    case REQUEST_ITEM_PRICE:
    case REQUEST_COMMODITY_DETAILS:
    case REQUEST_ALL_LOADING_AREAS:
    case REQUEST_ALL_PRICE_MODULE_ITEMS:
    case REQUEST_LOADING_AREA_DETAILS:
    case FETCH_SEGMENT_CODES:
    case FETCH_SEGMENT_VERSIONS:
    case FETCH_SEGMENT_VENDOR_MAPPING:
    case FETCH_COST_FILE_TEMPLATE:
    case FETCH_SEGMENT_DETAILS:
    case REQUEST_SEGMENT_DETAILS_BY_SEGMENT_VERSION:
    case REQUEST_WAREHOUSES_AND_OPCOS:
      return {
        ...state, type: 'modal', show: true, message: 'Loading...'
      };
    case REQUEST_VENDORS_BY_ITEM:
      return {
        ...state, type: 'modal', show: true, message: 'Loading vendors for selected item...'
      };
    case REQUEST_SUPPLIER_ONBOARD_DETAILS:
    case REQUEST_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS:
      return {
        ...state,
        type: 'modal',
        show: true,
        message: 'Loading user associations...',
      };

    case REQUEST_BUSINESS_CENTER_DETAILS:
      return {
        ...state, type: 'modal', show: true, message: 'Loading business centers...', isBusinessCenterLoading: true
      };
    case FETCH_ITEM_GROUPS:
      return {
        ...state, type: 'modal', show: true, message: 'Loading item groups...'
      };
    case REQUEST_AGREEMENT_NUMBERS:
      return {
        ...state, type: 'modal', show: true, message: 'Loading agreement numbers...'
      };
    case FETCH_AGREEMENTS_SEARCH_DATA:
      return {
        ...state, type: 'modal', show: true, message: 'Loading agreements...'
      };

    case REQUEST_PRICE_RECORD_TYPES:
      return {
        ...state, type: 'modal', show: true, message: 'Loading price record types...'
      };

    case SUBMIT_SUPPLIER_SUPPORT_REQUEST:
      return {
        ...state, type: 'modal', show: true, message: 'Submitting Supplier Support Request...'
      };

    case SUBMIT_WORKSPACE_REQUEST:
      return {
        ...state, type: 'modal', show: true, message: 'Submitting Request...'
      };

    case UPDATE_SELECTED_REQUEST_STATUS:
      return {
        ...state, type: 'modal', show: true, message: 'Updating Request Status...'
      };

    case SUBMIT_WORKSPACE_REQUEST_ACTION_CHANGE:
      return {
        ...state, type: 'modal', show: true, message: 'Updating Request...'
      };

    case SUBMIT_GENERATE_COST_REPORTS:
      return {
        ...state, type: 'modal', show: true, message: 'Generating Variance Reports...'
      };

    case ADD_WORKSPACE_REQUEST_COMMENT:
      return {
        ...state, type: 'modal', show: true, message: 'Posting message...'
      };

    case SAVE_SUPERVISOR_FOR_USER:
    case REMOVE_SUPERVISOR_OF_USER:
    case SAVE_VENDORS_ASSOCIATION_FOR_USER:
    case SAVE_GROUP:
    case SAVE_DIRECT_USER_GROUP_ASSOCIATION:
    case SAVE_SAS_VALUE_FOR_VENDOR:
    case ADD_SAS_VALUE_FOR_VENDOR:
    case SAVE_SAS_FD_DETAILS_FOR_ITEM:
    case REQUEST_LOADING_AREA_CREATE:
    case CREATE_MODULE_GROUP:
    case CREATE_COMMODITY_GROUP:
    case SAVE_SEGMENT_DETAILS:
    case UPDATE_SEGMENT_DETAILS:
    case SAVE_COST_FILE_TEMPLATE:
      return {
        ...state, type: 'modal', show: true, message: 'Saving...'
      };

    case DELETE_REPORT_TEMPLATE:
    case DELETE_COST_FILE_TEMPLATE:
    case REQUEST_MODULE_GROUP_DELETE:
    case REQUEST_COMMODITY_GROUP_DELETE:
    case REQUEST_LOADING_AREA_DELETE:
      return {
        ...state, type: 'modal', show: true, message: 'Deleting...'
      };
    case DELETE_SEGMENT_DETAILS:
      return {
        ...state, type: 'modal', show: true, message: `${data?.action === SEGMENT_DETAIL_ACTION_TYPES.SET_AS_INACTIVE ? 'Setting as Inactive...' : 'Deleting...'}`
      };

    case REQUEST_MODULE_GROUP_REACTIVATE:
    case REQUEST_COMMODITY_GROUP_REACTIVATE:
    case REQUEST_LOADING_AREA_REACTIVATE:
      return {
        ...state, type: 'modal', show: true, message: 'Reactivating...'
      };

    case REQUEST_SAS_FD_FILE_IMPORT:
      return {
        ...state, type: 'modal', show: true, message: 'Uploading SAS/FD File...'
      };

    case REQUEST_OVERAGE_FILE_IMPORT:
      return {
        ...state, type: 'modal', show: true, message: 'Uploading Cost Impact Earned Income File...'
      };

    case REQUEST_FILE_TRANSFER_DETAILS:
    case REQUEST_832_FILES:
    case REQUEST_REPORTS_LOG:
    case REQUEST_VENDOR_PRICE_FILES_IMPORT_LOG:
    case REQUEST_USER_PROFILE_DETAILS:
    case REQUEST_USER_PROFILE_DETAILS_OF_SELECTED_USER:
    case REQUEST_HELP_TOPIC_CONTENT:
      return { ...state, type: 'spinner', show: true };

    case UPDATE_SUPPLIER:
    case SAVE_SUPPLIER:
      return {
        ...state, type: 'modal', show: true, message: 'Saving Supplier Profile...',
      };
    case TRIGGER_UPDATE_SUPPLIER_CONTACT:
      return {
        ...state, type: 'modal', show: true, message: 'Updating Supplier Contact Details...',
      };

    case OPEN_LOADER_FOR_MASS_ITEM_UPLOAD_OPERATION:
    case OPEN_LOADER_FOR_MARKET_GROUP_OPERATION:
      return {
        ...state, type: 'modal', show: true, message: data
      };

    case REQUEST_MODULE_PRICE_EXPORT:
    case REQUEST_MODULE_GROUPS_ASSOCIATIONS:
      return {
        ...state, type: 'modal', show: true, message: 'Loading Module Details...',
      };
    case REQUEST_MODULE_PRICE_IMPORT:
      return {
        ...state, type: 'modal', show: true, message: 'File is Uploading...',
      };
    default:
      return state;
  }
}
